import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/pages.css';

const Register = () => {
  return (
    <div style={{ background: '#ffffff', minHeight: 'calc(100vh - 70px)', padding: '2rem' }}>
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <h1 style={{ fontSize: '2.5rem', fontWeight: 700, color: '#1a1a1a', letterSpacing: '-1px', marginBottom: '0.5rem', margin: '0 0 0.5rem 0' }}>
            Create Your Account
          </h1>
          <p style={{ color: '#666', fontSize: '1rem', lineHeight: 1.6, margin: 0 }}>
            Join the Grit Lab Africa Bootcamp and start your learning journey
          </p>
        </div>

        {/* Registration Form Container */}
        <div 
          style={{ 
            width: '100%', 
            background: '#f9f9f9',
            border: '1px solid #e8e8e8',
            borderRadius: '12px',
            overflow: 'hidden',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
            marginBottom: '2rem'
          }}
        >
          <iframe 
            src="https://docs.google.com/forms/d/e/1FAIpQLSe90G2wpCipspoilL2DZKxooc3493P749g4mkJWnFGj6fAtOg/viewform?embedded=true" 
            width="100%" 
            height="1000" 
            frameBorder="0" 
            marginHeight="0" 
            marginWidth="0" 
            style={{ border: 'none', display: 'block' }}
            title="GLA Bootcamp Registration Form"
          >
            Loading form...
          </iframe>
        </div>

        {/* Footer */}
        <div style={{ textAlign: 'center', paddingTop: '1.5rem', borderTop: '1px solid #e8e8e8' }}>
          <p style={{ fontSize: '0.95rem', color: '#666', margin: 0 }}>
            Already have an account?{' '}
            <Link to="/login" style={{ color: '#1a1a1a', fontWeight: 600, textDecoration: 'none' }}>
              Sign in here
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Register;

